/* eslint-disable jsx-a11y/no-distracting-elements */
import React from 'react'
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Banner from "../assets/images/home-banner.png";
import Banner2 from "../assets/images/home-banner-2.png";
import DCM from "../assets/images/EDU_MIN.png";
import "./style.scss";
import { STEMIcon, HE21Icon, AFPSIcon, HumanitiesIcon, PVAIcon } from '../assets/images/svg';
import ACERLogo from "../assets/images/ACER_logo.png";
import AshokaUniLogo from "../assets/images/Ashoka_Uni_logo.png";
import TEALogo from "../assets/images/TEA_Logo.png";
import IBLogo from "../assets/images/IB_logo.png";
import GMILogo from "../assets/images/GMI_logo.png";
import IITDelhiLogo from "../assets/images/IIT_Delhi_logo.png";
import LAHILogo from "../assets/images/LAHI_logo.png";
import MAHELogo from "../assets/images/MAHE_logo.png";
import NIFTLogo from "../assets/images/NIFT_logo.png";
import TISSLogo from "../assets/images/TISS_logo.png";
import VMCLogo from "../assets/images/VMC_logo.png";
import ENFLogo from "../assets/images/ENF_Logo.png";
import WhistlingWoodsLogo from "../assets/images/WhistlingWoodsLogo.png";
import NewItem from "../assets/images/new.jpg";
//import NoticeWebinarsForSpecilizationPDF from "../assets/docs/webinars_for_specialisations.pdf";
//import CircularGuidelinesPDF from "../assets/docs/Circular guidelines for admission 2023-24.pdf";
//import LastDateOfApplicationPDF from "../assets/docs/Last_Date_of_Application.pdf";
import EntranceTestDateSheetPDF from "../assets/docs/ASoSE Entrance Test Date Sheet.pdf";
import { useNavigate } from 'react-router-dom';
import { lang } from '../language';
import { LanguageContext } from '../App';
import  CuttOfList from "../assets/docs/Cut Off for STEM, Humanities, HE21 and PVA Specialisations in ASOSE aptitude test.pdf";
import Circular from "../assets/docs/SOSE, Class 11th Admission.pdf";
import Extension from "../assets/docs/circular extension grade 11.pdf";
import Humanities from "../assets/docs/BP_ASOSE_Humanities_11.pdf";
import Stem from "../assets/docs/BP_ASoSE_STEM_11.pdf";
import Blueprint from "../assets/docs/ASoSE_Aptitude Test_AFPS_Class 11th.pdf";
import CircularForAptitude from "../assets/docs/282_dt_17072023.pdf";
import CutOff11 from "../assets/docs/Cut Off-XI.pdf";
import CutOff9 from "../assets/docs/Cut Off-AFPS-IX.pdf";
import Interview from "../assets/docs/Walk In Interview Advertisement.pdf";
import CutOffSbS from "../assets/docs/Cut Off AFPS-XI.pdf";
import CirCular2024 from "../assets/docs/circular_reg_guidelines_for_admission.pdf";
import OnlineWebinar2024 from "../assets/docs/OnlineWebinar_dt_12122023.pdf";
import ExtendedCircular from "../assets/docs/602_09_dt_22122023.pdf";
import afpsSyllabus9 from '../assets/docs/ASoSE_Aptitude Test_AFPS_Class IX_VF.pdf';
import afpsSyllabus11 from '../assets/docs/ASoSE_Aptitude Test_AFPS_Class XI_VF.pdf'
import he21Syllabus from '../assets/docs/ASoSE_Aptitude Test _HE_21_VF.pdf';
import humanitiesSyllabus9 from '../assets/docs/ASoSE_ AT_9_Humanities.pdf';
import humanitiesSyllabus11 from '../assets/docs/ASOSE_AT_11_Humanities.pdf';
import pvaSyllabus from '../assets/docs/ASoSE_Aptitude Test _PVA_G9.pdf';
import stemSyllabus9 from '../assets/docs/ASoSE_Aptitude Test_STEM_Class_IX.pdf';
import stemSyllabus11 from '../assets/docs/ASoSE_Aptitude Test_STEM_Class_XI.pdf';
import TestDateCircular from '../assets/docs/66_dt_08012024sose.pdf';
import STEMIX_Result from '../assets/docs/STEM_IX.pdf';
import PVAIX_Result from '../assets/docs/PVA_IX.pdf';
import HUMIX_Result from '../assets/docs/HUM_IX.pdf';
import HE21IX_Result from '../assets/docs/HE21_IX.pdf';
import AFPS9_Result from '../assets/docs/AFPS_Shortlist_R2.pdf';
import CutoffsSoSEIX from '../assets/docs/CutoffsSoSEIX.pdf';
const Home = () => {

  const language = React.useContext(LanguageContext)
  const navigate = useNavigate();

  return (
    <div className='home'>
      <div className='banner'>
        <Carousel
          showArrows={true}
          autoPlay
          emulateTouch
          swipeable
          stopOnHover
          infiniteLoop
          showStatus={false}
          showThumbs={false}
        >
          <img src={Banner} alt="DBSE SOSE" title='DBSE SOSE' />
          <img src={Banner2} alt="DBSE SOSE" title='DBSE SOSE' />
        </Carousel>
      </div>
      <div className='dcmMessage'>
        <div className='updates'>
          <div className='updateHeading'>{lang[language].home.updatesHeading}</div>
          <div className='marquee'>
            <marquee direction="left" dangerouslySetInnerHTML={{ __html: lang[language].home.updates }} ></marquee>
          </div>
        </div>
        <div className='messageContainer'>
          <div className='dcmPic'><img src={DCM} alt="DCM" title='Ms. Atishi'  /></div>
          <div className='message'>
            <div className='content' dangerouslySetInnerHTML={{ __html: lang[language].home.dcmMessage }}></div>
            <div className='name' dangerouslySetInnerHTML={{ __html: lang[language].home.dcmName }}></div>
            <div className='position' dangerouslySetInnerHTML={{ __html: lang[language].home.dcmPosition }}></div>

          </div>
        </div>
      </div>

      <div className='specialization'>
        <div className='specialization_container'>
          <div className='specialization_topic' dangerouslySetInnerHTML={{ __html: lang[language].home.specialization.heading }}></div>

          <div className='specialization_card' onClick={() => navigate("/specialisation/stem")}>
            <div className='icon'>{STEMIcon}</div>
            <div className='topic' dangerouslySetInnerHTML={{ __html: lang[language].home.specialization.stem }}></div>
            <div className='view-more' dangerouslySetInnerHTML={{ __html: lang[language].home.specialization.viewMore }}></div>
          </div>

          <div className='specialization_card' onClick={() => navigate("/specialisation/he21")}>
            <div className='icon'>{HE21Icon}</div>
            <div className='topic' dangerouslySetInnerHTML={{ __html: lang[language].home.specialization.he21 }}></div>
            <div className='view-more' dangerouslySetInnerHTML={{ __html: lang[language].home.specialization.viewMore }}></div>
          </div>

          <div className='specialization_card' onClick={() => navigate("/specialisation/afps")}>
            <div className='icon'>{AFPSIcon}</div>
            <div className='topic' dangerouslySetInnerHTML={{ __html: lang[language].home.specialization.afps }}></div>
            <div className='view-more' dangerouslySetInnerHTML={{ __html: lang[language].home.specialization.viewMore }}></div>
          </div>

          <div className='specialization_card' onClick={() => navigate("/specialisation/humanities")}>
            <div className='icon'>{HumanitiesIcon}</div>
            <div className='topic' dangerouslySetInnerHTML={{ __html: lang[language].home.specialization.humanities }}></div>
            <div className='view-more' dangerouslySetInnerHTML={{ __html: lang[language].home.specialization.viewMore }}></div>
          </div>

          <div className='specialization_card' onClick={() => navigate("/specialisation/pva")}>
            <div className='icon'>{PVAIcon}</div>
            <div className='topic' dangerouslySetInnerHTML={{ __html: lang[language].home.specialization.pva }}></div>
            <div className='view-more' dangerouslySetInnerHTML={{ __html: lang[language].home.specialization.viewMore }}></div>
          </div>

        </div>
      </div>

      <div className='notices'>
        <div className='notices_heading' dangerouslySetInnerHTML={{ __html: lang[language].home.notices.heading }}></div>
        <div className='notices_container'>
          <ul>
          <li style={{ display: "flex", alignItems: "center" }}>
           <img src={NewItem} alt="" style={{ width: "60px", height: "40px" }} />
           <a href={CutoffsSoSEIX} target="_blank" rel='noreferrer'>   
            <b>
            Cutoff for various specialisations in ASOSE Aptitude Test for admissions in class 9th in AY 2024-25.
            </b>
           </a>
             
          </li>

          <li style={{ display: "flex", alignItems: "center" }}>
           <img src={NewItem} alt="" style={{ width: "60px", height: "40px" }} />
           <a href={AFPS9_Result} target="_blank" rel='noreferrer'>   
           <b>Candidates shortlisted for Round 2 of Aptitude Test for Admissions in Dr. B. R. Ambedkar Schools of Specialised Excellence - Shaheed Bhagat Singh Armed Forces Preparatory School (SBS-AFPS) (Class 9)
           </b> 
           </a>
             
          </li>

        
          <li style={{ display: "flex", alignItems: "center" }}>
          
           <b>
              All candidates who have qualified for SBS - Armed Forces Preparatory School, Jharoda Kalan (Residential) (STAGE 2 (Interview)) (Class IX) can now download their Round 2 Admit Card. Please carefully check the instructions on the Admit Card.
           </b>
             
          </li>

          <li style={{ display: "flex", alignItems: "center" }}>
          
            <a href={STEMIX_Result} target="_blank" rel='noreferrer'>   
              <b>  List of Roll Numbers (Science, Technology, Engineering and Mathematics (STEM)) shortlisted for admissions in class 9th for AY 2024-25 </b>
              </a>
             
          </li>

          
          <li style={{ display: "flex", alignItems: "center" }}>
          
            <a href={PVAIX_Result} target="_blank" rel='noreferrer'>   
              <b>  List of Roll Numbers (Performing and Visual Arts) shortlisted for admissions in class 9th for AY 2024-25 </b>
              </a>
             
          </li>
          <li style={{ display: "flex", alignItems: "center" }}>
          
            <a href={HUMIX_Result} target="_blank" rel='noreferrer'>   
              <b>  List of Roll Numbers (Humanities) shortlisted for admissions in class 9th for AY 2024-25 </b>
              </a>
             
          </li>
          <li style={{ display: "flex", alignItems: "center" }}>
           
            <a href={HE21IX_Result} target="_blank" rel='noreferrer'>   
              <b>  List of Roll Numbers (High End 21st Century Skills (HE21CS)) shortlisted for admissions in class 9th for AY 2024-25 </b>
              </a>
             
          </li>
          


          <li style={{ display: "flex", alignItems: "center" }}>
             
              Results for admission (2024-25) in Dr. B. R. Ambedkar Schools of Specialised Excellence for  STEM (Class - IX), High End 21st Century Skills (Class - IX), Performing and Visual Arts (Class - IX)  and Humanities (Class - IX) have been published.
							

          </li>


          <li style={{ display: "flex", alignItems: "center" }}>
             
              All candidates who have qualified for  Humanities ASoSE Test (Round 2) can now download their Round 2 Admit Card. Please carefully check the instructions on the Admit Card.
                                                                                                     
          </li>

          <li style={{ display: "flex", alignItems: "center" }}>
              
              All candidates who have qualified for High End 21st Century Skills (STAGE 2) can now download their Round 2 Admit Card. Please carefully check the instructions on the Admit Card.
                                                                                                   
          </li>
          <li style={{ display: "flex", alignItems: "center" }}>
              
              All candidates who have qualified for Performing and Visual Arts ASoSE Test can now download their Round 2 Admit Card(s). Please carefully check the instructions on the Admit Card.
                                                    
          </li>
          <li style={{ display: "flex", alignItems: "center" }}>
             
              Admit Card for ASoSE Admission Test - 2024 are now available for Sepcialisation(s) : <br />
           
                        1. Performing and Visual Arts (Class - IX)<br />
                        2. High-end 21st Century Skills (Class - IX)<br />
                        3. Humanities (Class - IX)<br />
                        4. Shaheed Bhagat Singh - Armed Forces Preparatory School (Class - IX)<br />
                        5. Science, Technology, Engineering and Mathematics (STEM) (Class - IX)<br />
                        6. STEM – PCM (Engineering) (Class - XI)<br />
                        7. STEM – PCB (Medical) (Class - XI)<br />
                        8. Humanities (Class - XI)<br />
                        9. Shaheed Bhagat Singh - Armed Forces Preparatory School (Class - XI)
           
           </li>
          
           <li style={{ display: "flex", alignItems: "center" }}>
              
              <a href={TestDateCircular} target="_blank" rel='noreferrer'>
            
              Aptitude Test for Admission in Dr. B. R. Ambedkar Schools of Specialized Excellence (ASOSE).
              </a>
          </li>

          <li style={{ display: "flex", alignItems: "center" }}>
              
              <a href={ExtendedCircular} target="_blank" rel='noreferrer'>
              Please note that the correction window is now open till December 31, 2023. Applicants will be able to update their application form only once. Please ensure that you make the necessary corrections during this time and thoroughly review your application and submit again.
             </a>
          </li>
          
          <li style={{ display: "flex", alignItems: "center" }}>
           
              <a href={ExtendedCircular} target="_blank" rel='noreferrer'>
              The last date of submission of online application is extended upto 31st December, 2023.
             </a>
          </li>

          <li style={{ display: "flex", alignItems: "center" }}>
       
            
              <a href={he21Syllabus} target="_blank" rel='noreferrer'>   
              <b>  Aptitude Test Blueprint: HE-21 (Class IX) </b>
              </a>
             
          </li>

          <li style={{ display: "flex", alignItems: "center" }}>
         
            
              <a href={humanitiesSyllabus9} target="_blank" rel='noreferrer'>   
              <b>  Aptitude Test Blueprint: Humanities (Class IX) </b>
              </a>
             
          </li>

          <li style={{ display: "flex", alignItems: "center" }}>
         
            
              <a href={humanitiesSyllabus11} target="_blank" rel='noreferrer'>   
              <b>  Aptitude Test Blueprint: Humanities (Class XI) </b>
              </a>
             
          </li>

          <li style={{ display: "flex", alignItems: "center" }}>
            <a href={pvaSyllabus} target="_blank" rel='noreferrer'>   
              <b>  Aptitude Test Blueprint:  Performing and Visual Arts (PVA) (Class IX) </b>
              </a>
             
          </li>


          <li style={{ display: "flex", alignItems: "center" }}>
              <a href={stemSyllabus9} target="_blank" rel='noreferrer'>   
              <b>  Aptitude Test Blueprint:  STEM (Class IX) </b>
              </a>
             
          </li>

          <li style={{ display: "flex", alignItems: "center" }}>
              <a href={stemSyllabus11} target="_blank" rel='noreferrer'>   
              <b>  Aptitude Test Blueprint:  STEM (Class XI) </b>
              </a>
             
          </li>

          <li style={{ display: "flex", alignItems: "center" }}>
              <a href={afpsSyllabus11} target="_blank" rel='noreferrer'>   
              <b>  Aptitude Test Blueprint:  Shaheed Bhagat Singh - Armed Forces Preparatory School (Class XI) </b>
              </a>
             
          </li>

          <li style={{ display: "flex", alignItems: "center" }}>
              <a href={afpsSyllabus9} target="_blank" rel='noreferrer'>   
              <b>  Aptitude Test Blueprint:  Shaheed Bhagat Singh - Armed Forces Preparatory School (Class IX) </b>
              </a>
             
          </li>


          <li style={{ display: "flex", alignItems: "center" }}>
              <a href="https://youtu.be/qsouvdyBWl8" target="_blank" rel='noreferrer'>   
              A Step-by-Step Guide to fill the admission form for Dr. B. R. Ambedkar Schools of Specialised Excellence (ASOSE)! Please watch this video
              </a>
          </li>

          <li style={{ display: "flex", alignItems: "center" }}>
              <a href={OnlineWebinar2024} target="_blank" rel='noreferrer'>
              Online webinars for all the specialisations of Dr. B.R. Ambedkar Schools of Specialised Excellence (ASoSE) for the students, parents and teachers.
             </a>
          </li>

          <li style={{ display: "flex", alignItems: "center" }}>
             
              <a href={CirCular2024} target="_blank" rel='noreferrer'>Guidelines for Admission in Dr. B. R. Ambedkar Schools of Specialised Excellence affiliated with the Delhi Board of School Education (DBSE)-Session 2024 25 in class 9th and class 11th.
             </a>
          </li>


          <li style={{ display: "flex", alignItems: "center" }}>
             <a href={CutOffSbS} target="_blank" rel='noreferrer'>Cut off marks for SBS - AFPS (Class XI).
             </a>
          </li>

          
          <li style={{ display: "flex", alignItems: "center" }}>
             <a href="javascript:void(0);" target="_blank" rel='noreferrer'> All candidates who have qualified for SBS - Armed Forces Preparatory School, Jharoda Kalan (Residential) (STAGE 2 (Interview)) [Class XI] can now download their Round 2 Admit Card. Please carefully check the instructions on the Admit Card.
             </a>
          </li>          






          <li style={{ display: "flex", alignItems: "center" }}>
              <a href={CutOff9} target="_blank" rel='noreferrer'> Cut off for ASoSE Aptitude Test for admissions in Armed Forces Preparatory School in class IX-2023.
             </a>
          </li> 




          <li style={{ display: "flex", alignItems: "center" }}>
              <a href={CutOff11} target="_blank" rel='noreferrer'> Cut Off for various Specialisations in ASOSE aptitude test for admissions in Class XI -2023.
             </a>
          </li> 


          <li style={{ display: "flex", alignItems: "center" }}>
            <a href="javascript:void(0);" target="_blank" rel='noreferrer'> Results for admission (2023-24) in Dr. B R Ambedkar Schools of Specialised Excellence for <u> STEM – PCM (Engineering) (Class XI),STEM – PCB (Medical) (Class XI) and Humanities (Class - XI) </u> have been published.
             </a>
          </li> 


          <li style={{ display: "flex", alignItems: "center" }}>
            <a href={CircularForAptitude} target="_blank" rel='noreferrer'> Aptitude Test for Admission in Class XI in Schools of Specialized Excellence (ASOSES) for the Academic Session 2023-24 (STEM-PCM, STEM-PCB, Humanities and AFPS only).
             </a>
          </li> 



          <li style={{ display: "flex", alignItems: "center" }}>
             <a href={Blueprint} target="_blank" rel='noreferrer'> The blueprint for aptitude test for admission in class 11th in AFPS.
             </a>
          </li> 
          
          <li style={{ display: "flex", alignItems: "center" }}>
              <a href={Extension} target="_blank" rel='noreferrer'> Last date of application for admission (Class XI) in Dr. B. R. Ambedkar Schools of Specialised Excellence has been extended. The application window will close on 30th June 2023.
             </a>
          </li> 

           <li style={{ display: "flex", alignItems: "center" }}>
             <a href={Humanities} target="_blank" rel='noreferrer'> The blueprint for aptitude test for admission in class 11th in Humanities stream.
             </a>
          </li>  


          <li style={{ display: "flex", alignItems: "center" }}>
             <a href={Stem} target="_blank" rel='noreferrer'> The blueprint for aptitude test for admission in class 11th in STEM stream.
             </a>
          </li>  


        

          <li style={{ display: "flex", alignItems: "center" }}>
            <a href="https://www.edudel.nic.in//sose/admission/Home.aspx" target="_blank" rel='noreferrer'>Admissions for Class 11 in following specialisations for Academic Year 2023-24 are now open -
              
              <ol>
              <li>1. STEM - Engineering (Class XI)</li>
              <li>2. STEM - Medical (Class XI)</li>
              <li>3. Humanities </li>
              <li>4. SBS - Armed Forces Preparatory School, Jharoda Kalan (Residential).</li>
              </ol>
             </a>
          </li>

          <li style={{ display: "flex", alignItems: "center" }}>
             <a href={Circular} target="_blank" rel='noreferrer'>Admission Circular 2023-24 for Class XI in Dr. B R Ambedkar Schools of Specialised Excellence. 
             </a>
          </li>

          <li style={{ display: "flex", alignItems: "center" }}>
              <a href="https://www.edudel.nic.in//sose/admission/Home.aspx" target="_blank" rel='noreferrer'>Result for admission (2023-24) in Dr. B R Ambedkar Schools of Specialised Excellence for Armed Forces Preparatory School (Class - IX) has been published.
             </a>
          </li>
          

          <li style={{ display: "flex", alignItems: "center" }}>
             <a href="https://www.edudel.nic.in//sose/admission/Home.aspx" target="_blank" rel='noreferrer'>Result for admission (2023-24) in Dr. B R Ambedkar Schools of Specialised Excellence for  <b>Performing and Visual Arts</b> has been published.
             </a>
          </li>
          
           


          <li style={{ display: "flex", alignItems: "center" }}>
             <a href="https://www.edudel.nic.in//sose/admission/Home.aspx" target="_blank" rel='noreferrer'>Results for admission (2023-24) in Dr. B R Ambedkar Schools of Specialised Excellence for  <b> STEM (Class IX)</b>, <b>High End 21st Century Skills (Class - IX)</b> and <b> Humanities (Class - IX)</b> have been published.
             </a>
          </li>

          <li style={{ display: "flex", alignItems: "center" }}>
              <a href={CuttOfList} target="_blank" rel='noreferrer'>
              Cut Off for STEM, Humanities, HE21 and PVA Specialisations in ASOSE aptitude test.
             </a>
          </li>

            <li style={{ display: "flex", alignItems: "center" }}><a href={EntranceTestDateSheetPDF} target="_blank" rel='noreferrer'>Aptitude test for admissions to Dr. B.R. Ambedkar Schools of Specialised Excellence (ASoSEs) for the academic session 2023-24.</a></li>
            
          </ul>
        </div>
        <div className='notices_heading' dangerouslySetInnerHTML={{ __html: lang[language].home.partners }}></div>
      </div>

      <div className='partners'>
        <marquee
          scrollamount={10}
          behavior="scroll"
        >
          <div className='logos'>
            
            <img src={ACERLogo} alt="ACER" />
            <img src={IBLogo} alt="Camp K12" />
            <img src={AshokaUniLogo} alt="Ashoka Uni" />
            <img src={TEALogo} alt="The Education Alliance" />
            <img src={GMILogo} alt="GMI" />
            <img src={ENFLogo} alt="Vasant Valley" />
          </div>

          <div className='logos'>
            <img src={IITDelhiLogo} alt="IIT Delhi" />
            <img src={LAHILogo} alt="LAHI" />
            <img src={MAHELogo} alt="MAHE" />
            <img src={NIFTLogo} alt="NIFT" />
            <img src={WhistlingWoodsLogo} alt="Whistling Woods" />
            <img src={TISSLogo} alt="TISS" />
            <img src={VMCLogo} alt="VMC" />
          </div>
        </marquee>
      </div>

      <div className='notices'></div>

    </div>
  )
}

export default Home